import cn from 'bem-cn';

import { Stack } from '../UI';

import { AliceDownloadQR } from './AliceDownloadQR';
import './AliceDownloadPopup.scss';

const b = cn('alice-download-popup');

export const AliceDownloadPopup = () => {
    return (
        <Stack spacing={16} className={b()} justifyContent="center">
            <p className={b('title')}>Пока доступно только в приложении Алисы</p>
            <AliceDownloadQR />
            <p className={b('description')}>Скачайте его, чтобы оживить свои фото, детские рисунки и не только</p>
        </Stack>
    );
};
